<br/>
<br/>
<div id="header_container" class="container">
  <div class="d-flex justify-content-center">
    <div class="card card-custom col-lg-10 col-md-10 col-sm-12 col-12">
      <div class="card-header card-title-custom" id="margin_1">
        How can we help you?
      </div>
      <div class="card-body">
        <div id="body_text">
          It's easy to keep your provider information up-to-date with us. Just
          select what type of provider you are, add your request(s), and tell us
          who to contact if we have any questions.
        </div>
      </div>
      <div class="row d-flex justify-content-around">
        <div class="ds_circles col-lg-5 col-md-5 col-sm-10 col-10">
          <div class="individual">
            <a
              class="card-link"
              (click)="showIndProvModal()"
              (keyup.enter)="showIndProvModal()"
              (keyup.space)="showIndProvModal()"
              tabindex="0"
              id="show-individual-provider-modal" 
            >
              <div class="card">
                <div class="card-body text-center">
                  <div class="icon icon-main">
            <!-- fa icon being styled with inline styles because [classes] was not updating the css  -->
                    <fa-icon
                      [icon]="faUser"
                      [fixedWidth]="true"
                      [styles]="{ color: 'white', transform: 'scale(1.3)' }"
                      size="2x"
                    ></fa-icon>
                  </div>
                  <div class="title-font aligin-middle"
                  for="show-individual-provider-modal">
                    Individual Provider
                  </div>
                  <p class="choice-text">
                    Choose this if you're just getting set up or making changes
                    to one or more individual providers.
                  </p>
                  <span class="link-look align-middle">Add a Request</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="ds_circles col-lg-5 col-md-5 col-sm-10 col-10">
          <div class="practice">
            <a 
              class="card-link"
              (click)="showDentPracModal()"
              (keyup.enter)="showDentPracModal()"
              (keyup.space)="showDentPracModal()"
              tabindex="0"
              id="show-dental-practice-modal"
            >
              <div class="card">
                <div class="card-body text-center size-sync">
                  <div class="icon icon-main">
                    <!-- fa icon being styled with inline styles because [classes] was not updating the css  -->
                    <fa-icon
                      [icon]="faStoreAlt"
                      [fixedWidth]="true"
                      [styles]="{ color: 'white', transform: 'scale(1.3)' }"  
                      size="2x"
                      
                    ></fa-icon>
                  </div>
                  <div class="title-font aligin-middle"
                  for="show-dental-practice-modal">
                    Dental Practice
                  </div>
                  <p class="choice-text">
                    Choose this if you're making changes to an entire practice
                    under a specific Tax ID.
                  </p>
                  <span class="link-look align-middle">Add a Request</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-display-request-table [requests]="requests"></app-display-request-table>
</div>
<app-ind-prov-modal></app-ind-prov-modal>
<app-dent-prac-modal></app-dent-prac-modal>
<app-confirm-modal></app-confirm-modal>
<br/>
<br/>
